<template>
  <b-row>
    <b-col sm="12">
      <b-card>
        <b-row class="pt-sm-1">
          <b-col sm="1">
            <span class="card-title wise-card-title">검색 조건</span>
          </b-col>
          <b-col sm="1"><strong>등록일</strong></b-col>
          <b-col sm="3">
            <date-picker v-model="fullDateTmp"
                         type="date"
                         style="width: 100%;"
                         range
                         placeholder="조회기간 선택"
                         :lang="datepickerLang"
                         @change="handleDateRangeChange"/>
          </b-col>
          <b-col sm="6">
            <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('ALL')">전체</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1WEEK')">1주일</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1MONTH')">1개월</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('6MONTH')">6개월</button>
            <button type="button" class="btn btn-outline-primary"s style="width: 61.72px;" v-on:click="dateRange('1YEAR')">1년</button>
          </b-col>


        </b-row>

        <b-row  class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>분류 기준</strong></b-col>
          <b-col sm="4" style="display: inline-flex;">
            <b-form-radio-group id="payorder-group" v-model="queryParams.view_type" :options="view_type_options" name="payorder-options"/>
          </b-col>
        </b-row>

        <b-row class="pt-sm-2" v-show="queryParams.view_type == 'DOWNLOAD'">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>옵션 기준</strong></b-col>
          <b-col sm="4" style="display: inline-flex;">
            <b-form-select id="basicSelect" v-model="queryParams.search_opt_code"
                           :plain="true"
                           :options="selectProductOptCodeArr"
                           :value="null">
            </b-form-select>
          </b-col>
        </b-row>

        <b-row class="pt-sm-2">

          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>아이디 검색</strong></b-col>
          <b-col sm="8">
            <b-form-input v-model="queryParams.keyword" placeholder=""
                          v-on:keyup="$event.keyCode === 13 ? getContentArStatisticsInfoUserList() : ''"/>
          </b-col>
          <b-col sm="2" style="text-align: center;">
            <b-button variant="primary" style="width: 100%;" v-on:click="getContentArStatisticsInfoUserList()">검색</b-button>
          </b-col>


        </b-row>
        <!-- 활성화 END -->
      </b-card>
    </b-col>
  </b-row>
</template>
<script>

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import _ from 'lodash'
import { EventBus } from "../../../../event-bus";

export default {
  name: 'ArInfoSearch',
  props: {
    productInfoItems: {
      type: Object
    },
    queryParams: {
      type: Object
    },
    fullDate: {
      type: Array,
    },
    selectProductOptCodeArr: {
      type: Array,
    }
  },
  components: {
    DatePicker
  },
  data () {
    return {
      datepickerLang: {
        yearFormat: "YYYY년",
        monthFormat: "M월",
        days:["일","월","화","수","목","금","토"]
      },
      view_type_options: [
        {text: '조회', value: 'VIEW'},
        {text: '추천', value: 'RECOMMAND'},
        {text: '다운로드', value: 'DOWNLOAD'},
        {text: '후속연구요청', value: 'RESEARCH'},
      ],
      fullDateTmp: [],

    }
  },

  mounted() {

  },
  methods: {

    getContentArStatisticsInfoUserList() {
      this.queryParams.keyword = this.queryParams.keyword.replace(/\s/g, '');
      EventBus.$emit('callFindDrUserList');
    },

    handleDateRangeChange() {
      this.$parent.fullDate = this.fullDateTmp;
    },
    // 날짜 정의
    dateRange(flag) {
      let endDate;
      let startDate;
      if(this.fullDateTmp.length === 0){
        endDate = new Date();
        startDate = new Date();
      }else{
        endDate = this.fullDateTmp[1];
        startDate = _.clone(this.fullDateTmp[1]);
      }

      if(flag == '1WEEK'){
        startDate.setDate(endDate.getDate() - 7);
      }else if(flag == '1MONTH'){
        startDate.setMonth(endDate.getMonth() - 1);
      }else if(flag == '6MONTH'){
        startDate.setMonth(endDate.getMonth() - 6);
      }else if(flag == '1YEAR'){
        startDate.setFullYear(endDate.getFullYear() - 1);
      }
      this.fullDateTmp = [startDate, endDate];
      if(flag == 'ALL'){
        this.fullDateTmp = [];
      }
      this.handleDateRangeChange();
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/statistics/content/component/ArInfo/ArInfoSearch.vue